var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenericSamlServer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4130_217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6674 13.306H8.00069C7.26431 13.306 6.66736 13.903 6.66736 14.6393V33.9727C6.66736 34.709 7.26431 35.306 8.00069 35.306H40.6674C41.4037 35.306 42.0007 34.709 42.0007 33.9727V14.6393C42.0007 13.903 41.4037 13.306 40.6674 13.306Z",
    stroke: "#2E3F58",
    strokeWidth: 0.833333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6674 13.306V35.306",
    stroke: "#2E3F58",
    strokeWidth: 0.833333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4794 21.4433H37.5",
    stroke: "#2E3F58",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4794 26.0227H33.4934",
    stroke: "#2E3F58",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.596 29.5373C10.2754 29.6973 9.80602 29.8707 9.45135 30.0293H19.7547C19.3865 29.8359 19.0038 29.6714 18.61 29.5373C16.7434 28.8847 16.114 28.232 16.114 26.9273C16.114 26.1033 16.7434 26.4353 16.904 24.958C17.064 24.3053 17.5334 24.958 17.694 23.4913C17.7045 23.3618 17.6803 23.2317 17.6239 23.1146C17.5676 22.9975 17.4811 22.8974 17.3734 22.8247C17.4669 22.341 17.5204 21.8504 17.5334 21.358C17.854 20.7053 17.2127 18.576 14.6827 18.576C14.2897 18.54 13.8934 18.5843 13.5181 18.7063C13.1427 18.8283 12.7961 19.0255 12.4994 19.2858C12.2027 19.546 11.9621 19.864 11.7922 20.2203C11.6224 20.5765 11.5268 20.9636 11.5114 21.358C11.5129 21.8512 11.5666 22.3428 11.6714 22.8247C11.5435 23.0221 11.487 23.2574 11.5114 23.4913C11.6714 24.958 12.1407 24.304 12.3014 24.958C12.622 26.4347 13.0914 26.1027 13.0914 26.9273C13.092 28.232 12.462 28.8847 10.596 29.5373Z",
    fill: "#2E3F58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4130_217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericSamlServer);
export default __webpack_public_path__ + "static/media/Generic_SAML_server.669f8631093212bcea8d05ace1ec541c.svg";
export { ForwardRef as ReactComponent };